<div>
  <table class="widget-legend">
    <tr *ngFor="let legend of legendData">
      <td class="widget-legend-row" colspan="3">
        <span [ngStyle]="{'height':'12px', 'width':'12px', 'background-color':legend.color, 'display':'inline-block'}"></span>
        <span class="widget-legend-detail">{{legend.key}}</span>
      </td>
    </tr>
  </table>
</div>

